import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
  ButtonBase,
} from "@reusejs/react";
import { ChatAltIcon } from "@heroicons/react/outline";

const Actions = () => {
  return (
    <div className="mt-8 flex justify-center flex-col md:flex-row">
      <div className="mr-2 w-full mb-4 md:mb-0 md:w-[initial]">
        <ButtonBase
          variant="primary"
          type="submit"
          label="Talk to our Expert"
          onClick={() => {
            console.log("button clicked");
          }}
          buttonBaseClasses={{
            font: "text-sm font-medium",
            backgroundColor: "bg-blue-600 hover:bg-blue-700",
            textColor: "text-white",
            border: "any",
            padding: "px-4 py-3",
            width: "w-full md:w-[initial]",
          }}
        />
      </div>
      <ButtonBase
        variant="primary"
        type="submit"
        label="Live Support"
        onClick={() => {
          console.log("button clicked");
        }}
        buttonPrefix={<ChatAltIcon width="20" height="20" className="mr-2" />}
        buttonBaseClasses={{
          font: "text-sm font-medium",
          backgroundColor: "bg-transparent",
          textColor: "text-black hover:text-blue-700",
          border: "border border-black border hover:border-blue-700",
          width: "w-full w-[initial]",
        }}
      />
    </div>
  );
};

export default function StillHaveQuestions(props: any) {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "py-10 md:py-20 bg-gray-50",
        innerContainerStyles: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-0",
      }}
    >
      <IconTitleDescriptionActionCard
        title={props.stillHaveQuestionsSectionData.heading.title}
        description={props.stillHaveQuestionsSectionData.heading.description}
        actions={<Actions />}
        itemTitleDescriptionCardBaseClasses={{
          iconWrapper:
            "flex h-12 w-12 items-center justify-center rounded-md text-white",
          titleWrapper: "mt-2 text-center",
          titleStyles: "text-xl md:text-4xl font-extrabold",
          descriptionWrapper: "text-center mt-3 sm:mt-4 max-w-xl mx-auto",
          descriptionStyles: "text-base md:text-lg text-gray-500 leading-6",
          actionWrapper: "mt-2 text-left",
        }}
      />
    </SectionContainerBase>
  );
}
